const renderInternal = (defaultProps, template, ...slots) => props => {
  const result = [];
  const combinedProps = { ...defaultProps, ...props };
  for (let i = 0; i < template.length + slots.length; i++) {
    // This interleaves template parts and slots.
    let particle = (i % 2) === 0 ? template[i / 2] : slots[(i - 1) / 2];

    // A slot may be a function to be executed.
    if (typeof particle === 'function') {
      particle = particle(combinedProps);
    }

    // Put anything in the resultset that turns out is printable.
    if (
      (typeof particle === 'string' && particle.length > 0) ||
      (typeof particle === 'number' && !Number.isNaN(particle)) ||
      (typeof particle === 'boolean') ||
      (typeof particle === 'bigint')
    ) {
      result.push(particle);
    }
    else if (typeof particle === 'symbol') {
      result.push(particle.toString());
    }
    else if (typeof particle === 'object') {
      if (particle instanceof Date) {
        result.push(particle.toISOString());
      }
      else if (particle !== null) {
        result.push(JSON.stringify(particle));
      }
    }
  }
  return result.join('');
};

/**
 * Creates a template renderer for a tagged template string. Each slot can be a function that is executed when the template is called.
 * @returns A renderer function, on its turn, renders the template out into a string.
 */
const render = (defaultProps, ...args) => {
  if (Array.isArray(defaultProps) && args.length >= 0) {
    // These are not default props, the `render` function is used directly as a tagged template function.
    return renderInternal({}, defaultProps, ...args);
  }
  else if (typeof defaultProps === 'object' && defaultProps !== null) {
    // Default props found, the `render` function is used as a function that must return a template tag.
    return (template, ...slots) => renderInternal(defaultProps, template, ...slots);
  }
};

export default render;
